import { render, staticRenderFns } from "./AddMr.vue?vue&type=template&id=447e3538&scoped=true&"
import script from "./AddMr.vue?vue&type=script&lang=js&"
export * from "./AddMr.vue?vue&type=script&lang=js&"
import style0 from "./AddMr.vue?vue&type=style&index=0&id=447e3538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447e3538",
  null
  
)

export default component.exports